<template>
    <div class="land-yadnex-map">
        <div class="map-container">
            <div class="map" id='YmapLocation'></div>
        </div>
        <div class="container" v-if="salesCard.project_land_site.location_yandex_pins != null && salesCard.project_land_site.location_yandex_pins != false">
            <div class="map-pins">
                <div class="col">
                    <div class="pin" v-for="(item, index) in salesCard.project_land_site.location_yandex_pins.slice(0, 3)" :key="index">
                        <div class="count">{{index + 1}}</div>
                        <h3>{{item.name}}</h3>
                    </div>
                </div>
                <div class="col" v-if="salesCard.project_land_site.location_yandex_pins.length > 3">
                    <div class="pin" v-for="(item, index) in salesCard.project_land_site.location_yandex_pins.slice(3, 6)" :key="index">
                        <div class="count">{{index + 4}}</div>
                        <h3>{{item.name}}</h3>
                    </div>
                </div>
                <div class="col" v-if="salesCard.project_land_site.location_yandex_pins.length > 6">
                    <div class="pin" v-for="(item, index) in salesCard.project_land_site.location_yandex_pins.slice(6, 10)" :key="index">
                        <div class="count">{{index + 7}}</div>
                        <h3>{{item.name}}</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-yandex-map',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            contactsSetup: 'loadContactsPage',
        }),
        methods: {
            initMapContacts() {
                const _self = this;
                this.$loadScript("https://api-maps.yandex.ru/2.1.75/?apikey=5ec4cf69-f505-4a8a-8b6d-70d1e6402870&lang=ru_RU")
                .then(() => {
                    // if (this.cityProject != null && this.contactsSetup != null) {
                    // var location = this.cityProject;
                    // var marker = this.contactsSetup.map_marker;
                    var zoom = this.salesCard.project_land_site.location_yandex_params.zoom;
                    // var links = $('#sales-land-office-items .office-item');
                    var Ymap;
                    var myPlacemark;
                    var myPins;
                    var i;
                    ymaps.ready().then(function() {
                        
                        var initMap = function() {
                            Ymap = new ymaps.Map('YmapLocation', {
                                center: [_self.salesCard.project_land_site.location_yandex_params.lat, _self.salesCard.project_land_site.location_yandex_params.lng],
                                zoom: zoom,
                                controls: ['fullscreenControl'],
                                behaviors: ["drag", "rightMouseButtonMagnifier", "multiTouch"]
                            },{suppressMapOpenBlock: true, minZoom: 3, maxZoom: 20});
                            Ymap.controls.add('zoomControl', {position: {left: '10px', top: '180px'}});
                        };

                        var setCenterOffset = function() {
                            var pixelCenter = Ymap.getGlobalPixelCenter('YmapLocation');
                            pixelCenter = [
                                pixelCenter[0] + 300,
                                pixelCenter[1] - 20
                            ];
                            var geoCenter = Ymap.options.get('projection').fromGlobalPixels(pixelCenter, Ymap.getZoom());
                            Ymap.setCenter(geoCenter);
                        };


                        var buildMainPin = function() {
                            // console.log(_self.salesCard.map_lat, _self.salesCard.map_lng, _self.salesCard.project_land_site.location_yandex_params.marker, 'AZAZAZAZ');
                            var lat = _self.salesCard.map_lat,
                                lng = _self.salesCard.map_lng;
                            myPlacemark = new ymaps.Placemark([lng, lat], {}, {
                                iconLayout: 'default#image',
                                iconImageHref: _self.salesCard.project_land_site.location_yandex_params.marker,
                                iconImageSize: [300, 115],
                                iconImageOffset: [-295, 0]
                            });
                            Ymap.geoObjects.add(myPlacemark);
                        };

                        

                        var buildPinsOnMap = function() {
                            if (_self.salesCard.project_land_site.location_yandex_pins != null && _self.salesCard.project_land_site.location_yandex_pins != false) {
                                for (i = 0; i < _self.salesCard.project_land_site.location_yandex_pins.length; i++) {
                                    var lat = _self.salesCard.project_land_site.location_yandex_pins[i].lat,
                                        lng = _self.salesCard.project_land_site.location_yandex_pins[i].lng;
                                    myPins = new ymaps.Placemark([lat,lng], {}, {
                                        iconLayout: 'default#image',
                                        iconImageHref: 'https://sales.bazis.kz/cms/media/2021/03/shablon_map_marker_new_' + parseInt(i + 1)  + '.svg',
                                        iconImageSize: [30, 30],
                                        iconImageOffset: [-10, -20]
                                    })

                                    Ymap.geoObjects.add(myPins);
                                }
                            }
                            // if (_self.officeCards.length == 1) {
                            //     Ymap.setCenter([_self.officeCards[0].office_map_lng, _self.officeCards[0].office_map_lat]);
                            // }
                        };

                        // var destroyMap = function() {
                        //     Ymap.destroy();
                        // };

                        // var updateMap = function() {
                        //     destroyMap();
                        //     initMap();
                        //     buildPinsOnMap();
                        // };

                        // var clicker = function() {
                        //     $('#sales-land-contacts-city-filter a').on('click', function() {
                        //         setTimeout(() => {
                        //             updateMap();
                        //             $('#sales-land-contacts-city-filter a').each(function(i, elem) {
                        //                 $(elem).on('click', function() {
                        //                     // _self.animateMap = false;
                        //                     setTimeout(() => {
                        //                         updateMap();
                        //                         setTimeout(() => {
                        //                             // _self.animateMap = true;
                        //                         }, 250);
                        //                     }, 350);
                        //                 })
                        //             })
                        //         }, 350);
                        //     });
                        // };

                        // _self.$store.watch(
                        //     (state) => state.pinCoords.lat,
                        //     (newValue) => {
                        //         if (newValue) {
                        //             // console.log(newValue, 'PIN COORDS')
                        //             Ymap.panTo([_self.pinCoords.lng, _self.pinCoords.lat], {
                        //                 safe: false,
                        //                 smooth: true,
                        //                 flying: false,
                        //                 duration: 600,
                        //             })
                        //             .then(function() {
                        //                 Ymap.setZoom(17, { 
                        //                     smooth: true
                        //                 })
                        //             })
                        //         }
                        //     }
                        // );

                        initMap();
                        setCenterOffset();
                        buildMainPin();
                        buildPinsOnMap();
                        // buildPinsOnMap();
                        // clicker();
                    });
                })
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.initMapContacts();
            // this.$store.watch(
            //     (state) => state.salesCard,
            //     (newValue) => {
            //         // console.log(newValue, 'promo test');
            //         // this.initFilterCityByPageLoad();
            //         this.initMapContacts();
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-yandex-map.scss';
    @import '@/styles/respond/sales/sales-land-partials/land-yandex-map-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>